import { Stack, Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { tailwindPalette } from "../../../../theme/tailwindPalette"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { MatchEnvironment } from "../../../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../../environment/envTypes"
import { ComingSoonPlaceholder } from "../../../../../shared/components/placeholders/ComingSoonPlaceholder"
import { MeetingSection } from "../components/meetigs/MeetingSection"
import { GuestCheckInSection } from "../components/guestCheckIn/CheckInSection"

const useStyles = makeStyles()(() => ({
    container: {
        paddingTop: "3rem",
        backgroundColor: tailwindPalette.blue[50],
    },
    sectionTitle: {
        fontWeight: "bold",
        fontSize: "1.25rem",
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
    },
    sectionContent: {
        padding: "1rem 0",
        borderBottom: "1px solid #E5E7EB",
    },
    row: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "1rem",
    },
    noDataContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "6rem",
    },
}))

export function ServiceCenterReportsHome() {
    const { classes } = useStyles()

    return (
        <>
            <MatchEnvironment environments={[EnvironmentType.Prod, EnvironmentType.QA]}>
                <LocalizedStrict id="service-center-home-coming-soon-placeholder" attrs={{ title: true, body: true }}>
                    <ComingSoonPlaceholder title="Coming soon" body="We are working to bring you this feature." />
                </LocalizedStrict>
            </MatchEnvironment>
            <MatchEnvironment environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo]}>
                <Box className={classes.container}>
                    <Stack direction={{ xs: "column", md: "row" }} spacing="1.5rem">
                        <MeetingSection />
                        <Stack flex={1} spacing="1rem">
                            <GuestCheckInSection />
                            {/*<CheckInSection />*/} {/*todo temporary hide*/}
                            {/*<NewsSection />*/} {/*todo temporary hide*/}
                        </Stack>
                    </Stack>
                </Box>
            </MatchEnvironment>
        </>
    )
}
